export const PRODUCT_LINK_ENV = {
  INT: 'integration',
  PRD: 'production',
};
